import React from 'react';

import Header from './components/Header';
import Main from './components/Main';

import './styles/App.css';

function App() {
    return (
        <>
            <Header />
            <Main />
        </>
    );
}

export default App;
